import { useEffect } from 'react';
import useWebSocket from 'react-use-websocket';
import { handleWsNotification } from '~/layouts/wsMessageHandler';
import useChatMessagesStore, {
  useChatMessagesStoreActions,
} from '~/stores/chatMessagesStore';
import useCodeGeneratorStore, {
  useCodeGeneratorStoreActions,
} from '~/stores/codeGeneratorStore';

export function GlobalWebSocket() {
  const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL as string;

  const chatMessageStoreActions = useChatMessagesStoreActions();
  const codeGeneratorStoreActions = useCodeGeneratorStoreActions();

  const { sendMessage, lastJsonMessage } = useWebSocket(WEBSOCKET_URL, {
    onOpen: () => {
      console.log("[WebSocket] Connection established to:", WEBSOCKET_URL);
      // Identify the connection on the backend.
      sendMessage(JSON.stringify({ action: 'getConnectionId' }));
    },
    onClose: () => {
      // If the socket closes during an active operation, reset generation flags.
      const isGenerating = useChatMessagesStore.getState().isGeneratingCode;
      const isUpdating = useChatMessagesStore.getState().isUpdatingCode;
      const isWaiting = useChatMessagesStore.getState().isWaitingAnswer;

      if (isGenerating || isUpdating || isWaiting) {
        chatMessageStoreActions.setIsGeneratingCode(
          false,
          'GlobalWebSocket onClose'
        );
        chatMessageStoreActions.setIsUpdatingCode(
          false,
          'GlobalWebSocket onClose'
        );
        chatMessageStoreActions.setIsWaitingAnswer(
          false,
          'GlobalWebSocket onClose'
        );
        codeGeneratorStoreActions.clearLoadingState();
      }
    },
    onError: () => {
      // Reset states on hard errors; WS may still auto-reconnect.
      chatMessageStoreActions.setIsGeneratingCode(
        false,
        'GlobalWebSocket onError'
      );
      chatMessageStoreActions.setIsUpdatingCode(
        false,
        'GlobalWebSocket onError'
      );
      chatMessageStoreActions.setIsWaitingAnswer(
        false,
        'GlobalWebSocket onError'
      );
      codeGeneratorStoreActions.clearLoadingState();
    },
    shouldReconnect: () => true,
    // We handle reconnection ourselves if needed; keep the socket alive across route changes.
    share: true,
  });

  useEffect(() => {
    if (lastJsonMessage && Object.keys(lastJsonMessage).length > 0) {
      handleWsNotification(lastJsonMessage as any, { auditorUserToken: undefined });
    }
  }, [lastJsonMessage]);

  useEffect(() => {
    const interval = window.setInterval(() => {
      try {
        sendMessage(JSON.stringify({ action: 'ping' }));
      } catch {
        // Ignore ping failures; socket will reconnect.
      }
    }, 180000);

    return () => window.clearInterval(interval);
  }, [sendMessage]);

  return null;
}

